import { Injectable } from '@angular/core';
import { AbstractOfflineStorageAsyncTimestampService } from '../abstract/abstract-offline-storage-async-timestamp.service';
import { ImmoIPProductChangesObject } from './immo-ip-product-changes-object';
import { ExpiredImmoIPProductChangesRemover } from './expired-immo-ip-product-changes-remover';
import { NgForage } from 'ngforage';
import { NgForageTimestampService } from '../../ng-forage/ng-forage-timestamp.service';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import AssetHelper from 'src/app/helpers/asset-helper';

@Injectable({
  providedIn: 'root',
})
export class ImmoIPProductChangesService extends AbstractOfflineStorageAsyncTimestampService<
  number,
  ImmoIPProductChangesObject,
  ExpiredImmoIPProductChangesRemover
> {
  constructor(
    protected ngForage: NgForage,
    protected ngForageTimestampService: NgForageTimestampService
  ) {
    super(
      'immo-ip-product-change-',
      'immo-ip-product-changes',
      ngForage,
      ngForageTimestampService
    );
  }

  protected instantiateRemover(): ExpiredImmoIPProductChangesRemover {
    return new ExpiredImmoIPProductChangesRemover(
      this,
      this.ngForage,
      this.ngForageTimestampService
    );
  }

  // Override
  protected verifyToStoreObject(object: ImmoIPProductChangesObject): void {
    if (object == null || object.id == null) {
      throw new Error(
        'immoIPProductChangesObject must not be null and id must not be null'
      );
    }
  }

  public convertToID(o: any): number {
    const toReturn = GeneralHelper.isNumeric(o) ? o : Number(o);
    if (!GeneralHelper.isNumeric(toReturn)) {
      throw new Error(`${o} could not be converted to number`);
    }
    return toReturn;
  }

  protected stringifyID(id: number): string {
    return id.toString();
  }

  // Override
  public async cleanupOfflineObject(
    object: ImmoIPProductChangesObject
  ): Promise<void> {
    if (object != null && CollectionHelper.isPopulated(object.offlineAssets)) {
      await Promise.all(
        object.offlineAssets.map((offlineAsset) =>
          this.ngForage.removeItem(
            AssetHelper.getStorageKeyFor(offlineAsset.localFileUuid)
          )
        )
      );
    }
  }
}
